import axios from "axios";
import type {
    LoginRequest,
    MasterLoginData,
    RefreshTokenData,
} from "~/lib/api/types/auth";

const fetchRefreshTokenRetryLimit = 3;
let currentFetchRefreshTokenRetries = 0;

export async function login(
    loginRequest: LoginRequest,
): Promise<MasterLoginData> {
    return (await axios.post<MasterLoginData>("/auth/login", loginRequest))
        .data;
}

export async function refresh(
    token: string | undefined,
): Promise<RefreshTokenData> {
    try {
        const result = (
            await axios.post<RefreshTokenData>("auth/refresh", {
                refresh_token: token,
            })
        ).data;

        return result;
    } catch (error) {
        if (currentFetchRefreshTokenRetries < fetchRefreshTokenRetryLimit) {
            currentFetchRefreshTokenRetries += 1;

            return refresh(token);
        }

        throw error;
    }
}
